import Api from '..'
import {
  ProductItemPublic,
  ProductItemPrivate,
  ProductCollectionItemPublic,
  ProductCollectionItemPrivate,
  ProductType
} from './types'

import each from 'lodash/each'

export default class ProductsApi extends Api {
  public endpoint = '/products'
  public productTypesEndpoint = 'product_types'

  // TODO we are assigning two types (public and private products) to the same
  // call. This should not be this way. Assign a call for private product
  // collection and one for public, because in the front end, we have to deal
  // with a bunch of 'maybes' because this call could 'technically' return two
  // different collections of types.
  public async getProductCollection(
    type: string | null = null,
    category: string | null = null,
    max: number | null = null,
    sortBy: 'views' | null = null
  ): Promise<ProductCollectionItemPublic[] | ProductCollectionItemPrivate[]> {
    const response = await this.http.get(this.endpoint, {
      params: {
        type: type,
        category: category,
        sort_by: sortBy,
        max: max
      }
    })
    const responseData:
      | ProductCollectionItemPublic[]
      | ProductCollectionItemPrivate[] = response.data
    return responseData
  }

  public async getProductInstance(
    uuid_or_slug: string
  ): Promise<ProductItemPublic | ProductItemPrivate> {
    const response = await this.http.get(`${this.endpoint}/${uuid_or_slug}`)
    const responseData: ProductItemPublic | ProductItemPrivate = response.data
    return responseData
  }

  public async createProductInstance(
    data: ProductItemPrivate | ProductItemPublic
  ): Promise<ProductItemPrivate> {
    // Remove properties that aren't needed.
    delete data.uuid
    delete data.views
    delete data.slug
    if ('registered_at' in data) {
      delete data.registered_at
    }

    const response = await this.http.post(`${this.endpoint}`, data)
    const responseData: ProductItemPrivate = response.data
    this.app.$bvToast.toast('Producto Creado con Éxito', {
      title: data.name,
      variant: 'success',
      autoHideDelay: 5000
    })
    return responseData
  }

  public async updateProductInstance(
    data: ProductItemPrivate | ProductItemPublic
  ): Promise<ProductItemPrivate> {
    const uuid = data.uuid

    // Remove properties that aren't needed.
    delete data.uuid
    delete data.views

    const response = await this.http.post(`${this.endpoint}/${uuid}`, data)
    const responseData: ProductItemPrivate = response.data
    this.app.$bvToast.toast('Producto Editado con Éxito', {
      title: data.name,
      variant: 'success',
      autoHideDelay: 5000
    })
    return responseData
  }

  public async deleteProductInstance(
    uuid: string
  ): Promise<ProductItemPrivate> {
    const response = await this.http.delete(`${this.endpoint}/${uuid}`)
    const responseData: ProductItemPrivate = response.data
    this.app.$bvToast.toast('Producto Eliminado con Éxito', {
      title: 'Producto Eliminado',
      variant: 'success',
      autoHideDelay: 5000
    })
    return responseData
  }

  // Product Types
  public async getProductTypeCollection(): Promise<ProductType[]> {
    const response = await this.http.get(this.productTypesEndpoint)
    const responseData: ProductType[] = response.data
    return responseData
  }

  public async getProductTypeInstance(uuid: string): Promise<ProductType> {
    const response = await this.http.get(`${this.productTypesEndpoint}/${uuid}`)
    const responseData: ProductType = response.data
    return responseData
  }

  public async createProductTypeInstance(
    data: ProductType
  ): Promise<ProductType> {
    // Remove properties that aren't needed.
    delete data.uuid
    delete data.slug
    delete data.categories

    const response = await this.http.post(`${this.productTypesEndpoint}`, data)
    const responseData: ProductType = response.data
    this.app.$bvToast.toast('Departamento Creado con Éxito', {
      title: data.name,
      variant: 'success',
      autoHideDelay: 5000
    })
    return responseData
  }

  public async updateProductTypeInstance(
    data: ProductType
  ): Promise<ProductType> {
    const uuid = data.uuid

    // Remove properties that aren't needed.
    delete data.uuid
    delete data.slug
    each(data.categories, (category) => { delete category.slug })

    const response = await this.http.post(
      `${this.productTypesEndpoint}/${uuid}`,
      data
    )
    const responseData: ProductType = response.data
    this.app.$bvToast.toast('Departamento Editado con Éxito', {
      title: data.name,
      variant: 'success',
      autoHideDelay: 5000
    })
    return responseData
  }

  public async deleteProductTypeInstance(
    uuid: string
  ): Promise<ProductType> {
    const response = await this.http
      .delete(`${this.productTypesEndpoint}/${uuid}`)

    const responseData: ProductType = response.data
    this.app.$bvToast.toast('Departamento Eliminado con Éxito', {
      title: 'Departamento Eliminado',
      variant: 'success',
      autoHideDelay: 5000
    })
    return responseData
  }
}
